import { Prisma } from "@prisma/client";
import { simpleActivityValues } from "./activity.types";
import { customCalendarTypeValues } from "./events/custom-calendar.types";
import { eventDetailsForViewTypeValues } from "./event-view.types";
import { eventPicturesTypeValues } from "./events.types";
import { simplePricingValues } from "./pricing.types";
import { getStructureTypeValuesForEvent } from "./structures.types";

const eventForPreviewValues = Prisma.validator<Prisma.EventDefaultArgs>()({
  select: {
    ...eventDetailsForViewTypeValues.select,
    id: true,
    areBadgesOnline: true,
    pictures: eventPicturesTypeValues,
    image: {
      select: {
        key: true,
        name: true,
        type: true,
        updatedAt: true,
      },
    },
    dates: {
      select: {
        schedules: {
          ...eventDetailsForViewTypeValues.select.dates.select.schedules.select,
          orderBy: {
            fromDate: "asc",
          },
          select: {
            ...eventDetailsForViewTypeValues.select.dates.select.schedules.select,
            fromDate: true,
            toDate: true,
            timetables: {
              select: {
                ...eventDetailsForViewTypeValues.select.dates.select.schedules.select.timetables
                  .select,
                day: true,
                openingTime: true,
                closingTime: true,
              },
              orderBy: {
                day: "asc",
              },
            },
          },
        },
        exceptionalClosingDates: {
          ...eventDetailsForViewTypeValues.select.dates.select.exceptionalClosingDates,
          select: {
            ...eventDetailsForViewTypeValues.select.dates.select.exceptionalClosingDates.select,
            date: true,
          },
          orderBy: {
            date: "asc",
          },
        },
        isContinuous: true,
      },
    },
    eventStructures: {
      include: {
        structure: getStructureTypeValuesForEvent(),
        promotionDateRanges: {
          select: {
            from: true,
            to: true,
          },
        },
      },
    },
    ticketTypes: {
      select: {
        activityId: true,
        name: true,
        userType: true,
        pricing: simplePricingValues,
      },
    },
    badgeTypes: {
      select: {
        name: true,
        userType: true,
        pricing: simplePricingValues,
      },
    },
    ticketing: true,
    customEventAppearance: {
      ...eventDetailsForViewTypeValues.select.customEventAppearance,
      select: {
        ...eventDetailsForViewTypeValues.select.customEventAppearance.select,
        model: true,
        opacity: true,
        backgroundColor: true,
        backgroundPicture: {
          select: {
            key: true,
            name: true,
            type: true,
          },
        },
      },
    },
    poster: {
      include: {
        addedTexts: {
          include: {
            style: true,
          },
        },
        logos: {
          include: {
            picture: true,
          },
        },
        pictures: {
          include: {
            picture: true,
          },
        },
      },
    },
    activities: {
      include: simpleActivityValues.include,
    },
    customCalendar: customCalendarTypeValues,
  },
});

export type EventForPreview = Prisma.EventGetPayload<typeof eventForPreviewValues>;
